export const InsertQna = async function(formData) {
    const requestURL = "question/insert";
    const requestParam = formData;

    const response = await o2.util.Http.requestMultipart(requestURL, requestParam);

    return response;
}

export const getQna = async function (questionId) {
    const requestURL = `/question/${questionId}`;
    const requestParam = {};

    const response = await o2.util.Http.requestData(requestURL, requestParam, {method: "GET"});

    return response;
};